import { BadgeProps } from '@mantine/core';
import React from 'react';

import { BadgeWithDot } from '@portals/core';
import { OrderPaymentStatusType } from '@portals/types';

interface InvoicePaymentStatusBadgeProps extends BadgeProps {
  status: OrderPaymentStatusType;
}
export function InvoicePaymentStatusBadge({
  status,
  ...badgeProps
}: InvoicePaymentStatusBadgeProps) {
  const { color, label } = getInvoicePaymentStatusColorAndLabel(status);

  return (
    <BadgeWithDot color={color} size="lg" radius="xl" {...badgeProps}>
      {label}
    </BadgeWithDot>
  );
}

function getInvoicePaymentStatusColorAndLabel(status: OrderPaymentStatusType) {
  switch (status) {
    case 'paid': {
      return {
        color: 'teal',
        label: 'Paid',
      };
    }

    case 'failed': {
      return {
        color: 'red',
        label: 'Payment failed',
      };
    }

    case 'expired': {
      return {
        color: 'gray',
        label: 'Expired',
      };
    }

    case 'pending': {
      return {
        color: 'amber',
        label: 'Pending',
      };
    }

    case 'awaiting_po_approval': {
      return {
        color: 'amber',
        label: 'Pending seller approval',
      };
    }

    case 'awaiting_po_upload': {
      return {
        color: 'amber',
        label: 'Requires PO',
      };
    }
  }
}
